export default function ValueScoreBadge({ score = 0, size = "md" }) {
  const tone =
    score >= 8.5 ? { bg: "bg-[#15FF73]", border: "border-[#0B0F0C]" } :
    score >= 6.5 ? { bg: "bg-[#FFE74C]", border: "border-[#0B0F0C]" } :
                   { bg: "bg-[#FAF6E8]", border: "border-[#0B0F0C]" };
  const px = size === "lg" ? "px-4 py-2 text-base" : "px-2.5 py-1 text-xs";
  return (
    <div data-testid="value-score-badge" className={`inline-flex items-center gap-1.5 rounded-full border-2 ${tone.border} ${tone.bg} ${px} font-mono-x font-bold shadow-[2px_2px_0_#0B0F0C]`}>
      <span className="text-[8px] uppercase tracking-widest opacity-60">Score</span>
      <span>{score.toFixed(1)}</span>
      <span className="text-[8px] opacity-60">/10</span>
    </div>
  );
}
